export default {
	title: "Llamada de Fichas",
	initialize: "Inicializar todas las llamadas de número 1",
	letter: "Letra",
	table: {
		guideMedium: "Guía / Médium",
		noMedium: "(sin médium)",
		noGuide: "(sin guía)",
	},
	noLettersAvailable: "No hay letras disponibles",
	actions: {
		"queue.reset": "cola reiniciada",
		"global.reset": "reinicio global",
		"ticket.reset": "ficha reiniciada",
	},
	popup: {
		status: "Estado",
		calledAt: "Llamado en",
		call: "Llamar",
		finish: "Finalizar",
		recall: "Re-llamar",
		reset: "Reiniciar",
		cancelledAt: "Cancelado en",
		confirmReset: "¿Confirmar reinicio de esta ficha?",
		consultant: "Consultante",
		finishedAt: "Finalizado en",
		reopen: "Reabrir",
		totalTime: "Tiempo total",
	},
	errors: {
		generic: "Ocurrió un error",
		initialize: "Error al inicializar llamadas",
		next: "Error al llamar la siguiente ficha",
		loadRitual: "Error al cargar ritual",
		ritualNotInProgress: "Este ritual no está en curso. Solo rituales abiertos permiten llamada de fichas.",
	},
	devReset: "Reset Dev",
	clearDisplay: "Limpiar Display",
	confirmDevReset: "¿Reiniciar TODAS las fichas? Esta acción no se puede deshacer.",
	displayDrawer: "Mensajes de la TV",
	exitFullscreen: "Salir",
	fullscreen: "Pantalla completa",
	messages: {
		called: "Ficha llamada con éxito",
		finished: "Ficha finalizada con éxito",
		globalResetDone: "Reinicio global realizado",
		initialized: "Fichas inicializadas con éxito",
		recalled: "Ficha rellamada",
		reconnected: "Conexión restablecida",
		reopened: "Ficha reabierta con éxito",
		resetDone: "Ficha reiniciada",
	},
	quickMessage: "Mensaje rápido",
	sendToDisplay: "Enviar a TV",
	stats: {
		called: "En atención",
		completed: "Finalizadas",
		pending: "Pendientes",
	},
};
